import {
  Edit,
  SimpleForm,
  TextInput,
  useRecordContext,
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  FunctionField,
  EditButton,
} from 'react-admin';
import { Box, Typography, Divider } from '@mui/material';
import { cleanListStyle } from '../styles/listStyles';
import { NAVY, ORDER_STATUS, badgeStyle, typo, layout } from '../styles/ds';

const OrderHistoryPanel = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Box mt={3} px={3} pb={3}>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="h6" fontWeight={700} color={NAVY} mb={1}>היסטוריית הזמנות</Typography>
      <List
        resource="orders"
        filter={{ customer_id: record.id }}
        pagination={false}
        actions={false}
        title=" "
        sx={cleanListStyle}
        sort={{ field: 'created_at', order: 'DESC' }}
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="id" label="#" />
          <NumberField
            source="total_price_ils"
            label="סה״כ ₪"
            options={{ style: 'currency', currency: 'ILS', minimumFractionDigits: 0 }}
          />
          <NumberField
            source="total_price_usd"
            label="סה״כ $"
            options={{ style: 'currency', currency: 'USD', minimumFractionDigits: 0 }}
          />
          <FunctionField
            label="סטטוס"
            render={r => (
              <span style={badgeStyle(ORDER_STATUS, r.status)}>
                {ORDER_STATUS[r.status]?.label || r.status}
              </span>
            )}
          />
          <DateField source="created_at" label="תאריך" />
          <EditButton resource="orders" label="" size="small" />
        </Datagrid>
      </List>
    </Box>
  );
};

const CustomerEdit = () => (
  <Edit title="עריכת לקוח">
    <>
      <SimpleForm>
        <Typography sx={{ ...typo.sectionTitle, mb: 1.5 }}>פרטי קשר</Typography>
        <Box sx={{ ...layout.formGrid, mb: 1 }}>
          <TextInput source="first_name" label="שם פרטי" fullWidth />
          <TextInput source="last_name"  label="שם משפחה" fullWidth />
          <TextInput source="phone"      label="טלפון" fullWidth />
          <TextInput source="email"      label="אימייל" fullWidth />
          <TextInput source="country"    label="מדינה" fullWidth />
          <TextInput source="city"       label="עיר" fullWidth />
        </Box>
        <Typography sx={{ ...typo.sectionTitle, mt: 2, mb: 1.5 }}>כתובת</Typography>
        <TextInput source="address"          label="כתובת" fullWidth />
        <TextInput source="shipping_address" label="כתובת למשלוח" fullWidth />
      </SimpleForm>
      <OrderHistoryPanel />
    </>
  </Edit>
);

export default CustomerEdit;
